import { Injectable, inject } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { FirebaseAwareService } from '../shared/firestore/firebase-aware.service';

export interface SubmitWithdrawalPublicPayload {
  fullName: string;
  email: string;
  bookingId: string;
}

export interface SubmitWithdrawalResult {
  withdrawalId: string;
}

@Injectable({ providedIn: 'root' })
export class WithdrawalService extends FirebaseAwareService {
  private functions = inject(Functions);

  async submitPublic(payload: SubmitWithdrawalPublicPayload): Promise<SubmitWithdrawalResult> {
    const call = this.inCtx(() =>
      httpsCallable<SubmitWithdrawalPublicPayload, SubmitWithdrawalResult>(
        this.functions,
        'submitWithdrawalRequest',
      ),
    );
    const result = await call({
      fullName: payload.fullName.trim(),
      email: payload.email.trim(),
      bookingId: payload.bookingId.trim(),
    });
    return result.data;
  }

  async submitAuthenticated(bookingId: string): Promise<SubmitWithdrawalResult> {
    const call = this.inCtx(() =>
      httpsCallable<{ bookingId: string }, SubmitWithdrawalResult>(
        this.functions,
        'submitWithdrawalRequest',
      ),
    );
    const result = await call({ bookingId: bookingId.trim() });
    return result.data;
  }
}
